import styled from 'styled-components'
import { View } from '@olxbr/design-system/web'

export const Content = styled(View)`
  width: 220px;
`

export const ChatWrapper = styled(View)`
  border-top-left-radius: var(--border-radius-sm);
  border-top-right-radius: var(--border-radius-sm);
  width: 100%;
  height: 100%;
  @media only screen and (min-width: 52.5rem) {
    width: 360px;
    height: 456px;
  }
`

export const ChatComponentsView = styled(View)`
  border-top-left-radius: var(--border-radius-sm);
  border-top-right-radius: var(--border-radius-sm);
  box-shadow: 0px 6px 10px 0px var(--color-neutral-110);
  z-index: var(--z-index-1000-top);
  position: absolute;
  right: 0;
  background-color: var(--color-neutral-70);

  @media only screen and (min-width: 1rem) {
    width: 100%;
    height: 100%;
  }

  @media only screen and (min-width: 52.5rem) {
    bottom: 0;
    width: 360px;
    height: 456px;
    float: right;
    margin-right: 1.5rem;
  }

  @media only screen and (min-width: 79.5rem) {
    margin-right: 0.75rem;
  }
`

export const AdViewBox = styled(View)`
  position:fixed;
  bottom:0;
  left:0;
  right:0;
  margin:auto;
  z-index: var(--z-index-1000-top);
  overflow: scroll;

  @media only screen and (min-width: 1rem) {
    width: 100%;
    height: 100%;
  }

  @media only screen and (min-width: 52.5rem) {
    width: 100%;
    height: 1px;
    overflow: initial;
  }

  @media only screen and (min-width: 79.5rem) {
    width: 79.5rem;
    height: 1px;
  }
`
